import { missingWidget } from '../../utils/helpers';

export default function headlineSecond() {
  const widgetName = 'headlineSecond';
  const $widget = $(`#${widgetName}`);
  const widgetOpts = typeof headlineSecondOpts === 'undefined' ? null : headlineSecondOpts;

  if (!widgetOpts) {
    missingWidget(widgetName);
    return;
  }

  return saffire.widgets.cardWidget($widget, {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    scriptPath: widgetOpts.scriptPath,
    itemsPerPanel: 1,
    maxItemsVisible: 1,

    cardWidgetLoaded: function (data, _owl, hasData) {
      if (hasData) {
        createheadlineSecond(data);
      } else {
        $widget.remove();
      }
    },
  });

  function createheadlineSecond(widgetData) {
    const { Title } = widgetData.items[0];

    $widget.replaceWith(`<h4 class="headline second-headline">${Title}</h4>`);
  }
}
